/* MRPIECE Winter 26 — extras.
   1. Quick view: [data-mw-qv] buttons open #MwQuickView, filled from
      <product url>?section_id=mw-quickview. Adds with /cart/add.js, then asks
      the theme's cart drawer to refresh and open (same as the Mix & Match rail).
   2. 3D tilt: subtle pointer tilt + glare on card, tile and collection images.
   3. Cart drawer upsell (sections/mw-cart-upsell.liquid).
   4. 3D flip cards (snippets/mw-flip-card.liquid).
   Both respect prefers-reduced-motion; tilt only runs on fine pointers. */
(function () {
  'use strict';
  if (window.__mwPlus) return;
  window.__mwPlus = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var emojiRe = /[\p{Extended_Pictographic}\u{1F1E6}-\u{1F1FF}\u{FE0F}\u{200D}\u{20E3}]/gu;

  function track(name, data) {
    data = data || {};
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('mrpiece:' + name, { detail: data })); } catch (e) {}
  }

  /* ------------------------------------------------------------------ 1 */
  var dialog, body, lastTrigger, controller;

  function sectionUrl(url) {
    var u = url.split('#')[0];
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'section_id=mw-quickview';
  }

  function openDialog() {
    if (!dialog.open) {
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('mw-qv-lock');
    requestAnimationFrame(function () { dialog.classList.add('is-in'); });
  }

  function closeDialog() {
    if (!dialog) return;
    dialog.classList.remove('is-in');
    document.documentElement.classList.remove('mw-qv-lock');
    if (controller) controller.abort();
    setTimeout(function () {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close(); else dialog.removeAttribute('open');
      body.innerHTML = '';
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    }, reduce ? 0 : 220);
  }

  function load(url) {
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    body.innerHTML = '<div class="mw-qv__loading"><span></span></div>';
    openDialog();
    fetch(sectionUrl(url), { signal: controller ? controller.signal : undefined, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('[data-mw-qv-product]');
        if (!root) throw new Error('empty');
        body.innerHTML = '';
        body.appendChild(document.importNode(root, true));
        setup(body.querySelector('[data-mw-qv-product]'));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url; // fall back to the product page
      });
  }

  function setup(root) {
    if (!root) return;
    root.querySelectorAll('[data-mw-clean]').forEach(function (el) {
      var t = el.textContent.replace(emojiRe, '').replace(/\s{2,}/g, ' ').trim();
      if (t) el.textContent = t;
    });

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-mw-qv-variants]').textContent); } catch (e) {}
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-mw-qv-option]'));
    var add = root.querySelector('[data-mw-qv-add]');
    var label = root.querySelector('[data-mw-qv-label]');
    var price = root.querySelector('[data-mw-qv-price]');
    var error = root.querySelector('[data-mw-qv-error]');
    var track_ = root.querySelector('[data-mw-qv-track]');
    var index = root.querySelector('[data-mw-qv-index]');
    var slides = track_ ? track_.children : [];

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var countEl = root.querySelector('.mw-qv__count');
    if (countEl && slides.length) countEl.lastChild.textContent = ' / ' + pad(slides.length);

    function current() { return track_ ? Math.round(track_.scrollLeft / (track_.clientWidth || 1)) : 0; }
    function go(i) {
      if (!track_ || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track_.scrollTo({ left: i * track_.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (track_) {
      track_.addEventListener('scroll', function () { if (index) index.textContent = pad(current() + 1); }, { passive: true });
    }
    root.querySelectorAll('[data-mw-qv-step]').forEach(function (b) {
      b.addEventListener('click', function () { go(current() + parseInt(b.getAttribute('data-mw-qv-step'), 10)); });
    });

    function selected() {
      return groups.map(function (g) {
        var on = g.querySelector('.mw-qv__chip.is-on');
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (sel[j] !== null && v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok && sel.indexOf(null) === -1) return v;
      }
      return null;
    }
    function refreshAvailability(sel) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('.mw-qv__chip').forEach(function (chip) {
          var probe = sel.slice(); probe[gi] = chip.getAttribute('data-value');
          var exists = false, avail = false;
          variants.forEach(function (v) {
            var ok = true;
            for (var j = 0; j < probe.length; j++) { if (probe[j] !== null && v.options[j] !== probe[j]) { ok = false; break; } }
            if (ok) { exists = true; if (v.available) avail = true; }
          });
          chip.classList.toggle('is-out', !avail);
          chip.classList.toggle('is-none', !exists);
        });
      });
    }
    function update() {
      var sel = selected();
      refreshAvailability(sel);
      var v = match(sel);
      groups.forEach(function (g, gi) {
        var chosen = g.querySelector('[data-mw-qv-chosen]');
        if (chosen) chosen.textContent = sel[gi] || '';
      });
      if (error) { error.hidden = true; error.textContent = ''; }
      if (!v) {
        add.disabled = true; label.textContent = 'Unavailable'; return;
      }
      add.setAttribute('data-variant-id', v.id);
      add.disabled = !v.available;
      label.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (price) {
        price.innerHTML = v.compare
          ? '<span class="is-sale"></span><s></s>'
          : '<span></span>';
        price.firstChild.textContent = v.price;
        if (v.compare) price.lastChild.textContent = v.compare;
      }
      if (v.media && track_) {
        for (var k = 0; k < slides.length; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(v.media)) { go(k); break; }
        }
      }
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var chip = e.target.closest('.mw-qv__chip');
        if (!chip || chip.classList.contains('is-none')) return;
        g.querySelectorAll('.mw-qv__chip').forEach(function (c) { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); });
        chip.classList.add('is-on'); chip.setAttribute('aria-pressed', 'true');
        update();
      });
    });
    if (groups.length) refreshAvailability(selected());

    add.addEventListener('click', function () {
      var id = parseInt(add.getAttribute('data-variant-id'), 10);
      if (!id || add.disabled) return;
      add.setAttribute('aria-busy', 'true'); add.disabled = true;
      var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
      if (!/\.js$/.test(url)) url += '.js';
      fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            error.textContent = (res.data && (res.data.description || res.data.message)) || 'Could not add this piece. Please try again.';
            error.hidden = false;
            add.disabled = false;
            return;
          }
          track('quick_view_add', { variant_id: id, product_url: root.getAttribute('data-url') });
          closeDialog();
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          }, reduce ? 0 : 240);
        })
        .catch(function () {
          error.textContent = 'Connection problem. Please try again.';
          error.hidden = false; add.disabled = false;
        })
        .finally(function () { add.removeAttribute('aria-busy'); });
    });
  }

  function initQuickView() {
    dialog = document.getElementById('MwQuickView');
    if (!dialog) return;
    body = dialog.querySelector('[data-mw-qv-body]');
    if (dialog.parentNode !== document.body) document.body.appendChild(dialog);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-mw-qv]');
      if (!btn) return;
      e.preventDefault();
      lastTrigger = btn;
      track('quick_view_open', { product_url: btn.getAttribute('data-mw-qv') });
      load(btn.getAttribute('data-mw-qv'));
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || (e.target.closest && e.target.closest('[data-mw-qv-close]'))) closeDialog();
    });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(); });
  }

  /* ------------------------------------------------------------------ 2 */
  var TILT = '.mw-card__media, .mw-tile__media, .mw-col__media';
  function initTilt() {
    if (reduce) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var active = null, raf = 0, px = 0, py = 0;
    function apply() {
      raf = 0;
      if (!active) return;
      var r = active.getBoundingClientRect();
      var x = Math.min(Math.max((px - r.left) / r.width, 0), 1);
      var y = Math.min(Math.max((py - r.top) / r.height, 0), 1);
      active.style.setProperty('--mw-rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
      active.style.setProperty('--mw-ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
      active.style.setProperty('--mw-gx', (x * 100).toFixed(1) + '%');
      active.style.setProperty('--mw-gy', (y * 100).toFixed(1) + '%');
    }
    function leave(el) {
      el.classList.remove('is-tilting');
      el.style.removeProperty('--mw-rx'); el.style.removeProperty('--mw-ry');
    }
    document.addEventListener('pointerover', function (e) {
      var el = e.target.closest && e.target.closest(TILT);
      if (el === active) return;
      if (active) leave(active);
      active = el || null;
      if (active) {
        if (!active.querySelector(':scope > .mw-glare')) {
          var g = document.createElement('i'); g.className = 'mw-glare'; g.setAttribute('aria-hidden', 'true');
          active.appendChild(g);
        }
        active.classList.add('is-tilting');
      }
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {
      if (!active) return;
      px = e.clientX; py = e.clientY;
      if (!raf) raf = requestAnimationFrame(apply);
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      if (!active) return;
      if (e.relatedTarget && active.contains(e.relatedTarget)) return;
      leave(active); active = null;
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ 3 */
  /* Cart drawer upsell: fetch sections/mw-cart-upsell and place it under the
     line items every time the drawer re-renders. */
  function initUpsell() {
    var timer = 0, seq = 0;
    function cleanText(root) {
      root.querySelectorAll('[data-mw-clean]').forEach(function (el) {
        var t = el.textContent.replace(emojiRe, '').replace(/\s{2,}/g, ' ').trim();
        if (t) el.textContent = t;
      });
    }
    function anchorIn(mini) {
      var item = mini.querySelector('[id^="CartDrawer-Item-"]');
      if (!item) return null;
      var list = item.closest('ul, ol, table') || item.parentElement;
      return list && mini.contains(list) ? list : null;
    }
    function render() {
      var minis = document.querySelectorAll('[id^="MiniCart-"]');
      if (!minis.length) return;
      var my = ++seq;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?section_id=mw-cart-upsell', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (my !== seq) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var block = doc.querySelector('[data-mw-upsell]');
          minis.forEach(function (mini) {
            mini.querySelectorAll('.mw-up-wrap').forEach(function (el) { el.remove(); });
            if (!block) return;
            if (!block.querySelector('.mw-up__item')) return;
            var anchor = anchorIn(mini);
            if (!anchor) return;
            var wrap = document.createElement('div');
            wrap.className = 'mw-up-wrap';
            wrap.appendChild(document.importNode(block, true));
            cleanText(wrap);
            anchor.insertAdjacentElement('afterend', wrap);
          });
        })
        .catch(function () {});
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(render, 160); }

    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var nodes = Array.prototype.slice.call(records[i].addedNodes).concat(Array.prototype.slice.call(records[i].removedNodes));
        var ours = nodes.length && nodes.every(function (n) { return n.nodeType !== 1 || (n.classList && n.classList.contains('mw-up-wrap')); });
        if (!ours) { schedule(); return; }
      }
    });
    function watch() {
      document.querySelectorAll('[id^="MiniCart-"]').forEach(function (mini) {
        if (mini.__mwUp) return;
        mini.__mwUp = true;
        observer.observe(mini, { childList: true });
      });
    }
    watch();
    schedule();
    document.addEventListener('cart:updated', function () { watch(); schedule(); });
    document.addEventListener('cart:refresh', function () { setTimeout(function () { watch(); schedule(); }, 400); });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-mw-up-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      if (!/\.js$/.test(url)) url += '.js';
      fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-mw-up-add'), 10), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          track('cart_upsell_add', { variant_id: btn.getAttribute('data-mw-up-add') });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        })
        .catch(function () { btn.textContent = 'Sold out'; btn.disabled = true; })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  /* ------------------------------------------------------------------ 4 */
  /* 3D flip cards (snippets/mw-flip-card.liquid). */
  function initFlip() {
    function setBack(card, open) {
      card.classList.toggle('is-flipped', open);
      var back = card.querySelector('.mw-flip__back');
      if (!back) return;
      back.setAttribute('aria-hidden', open ? 'false' : 'true');
      back.querySelectorAll('button, a').forEach(function (el) { el.tabIndex = open ? 0 : -1; });
      var first = open && (back.querySelector('.mw-flip__size:not([disabled])') || back.querySelector('[data-flip-add]'));
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 200);
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-flip-toggle], [data-flip-size], [data-flip-add]');
      if (!t) return;
      var card = t.closest('[data-mw-flip]');
      if (!card) return;
      e.preventDefault();
      if (t.hasAttribute('data-flip-toggle')) { setBack(card, !card.classList.contains('is-flipped')); return; }
      var add = card.querySelector('[data-flip-add]');
      if (t.hasAttribute('data-flip-size')) {
        card.querySelectorAll('[data-flip-size]').forEach(function (b) { b.classList.toggle('is-on', b === t); b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
        add.disabled = false; add.setAttribute('data-variant-id', t.getAttribute('data-flip-size')); add.textContent = 'Add to bag';
        var pr = card.querySelector('[data-flip-price]'); if (pr && t.getAttribute('data-price')) pr.textContent = t.getAttribute('data-price');
        return;
      }
      var id = parseInt(add.getAttribute('data-variant-id'), 10);
      if (!id || add.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      if (!/\.js$/.test(url)) url += '.js';
      fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) { add.textContent = 'Sold out'; add.disabled = true; return; }
          track('flip_card_add', { variant_id: id });
          add.textContent = 'Added';
          setTimeout(function () { setBack(card, false); add.textContent = 'Add to bag'; }, 900);
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        })
        .catch(function () { add.textContent = 'Try again'; })
        .finally(function () { add.removeAttribute('aria-busy'); });
    });
  }

  function init() { initQuickView(); initTilt(); initUpsell(); initFlip(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
